import { createI18n } from 'vue-i18n';

import { messages } from "@/locales";

export const defaultLocale = 'en';

/**
 * @param choice {number} a choice index given by the input to $tc: `$t('path.to.rule', choiceIndex)`
 * @returns a final choice index to select plural word by
 */
function pluralize (choice: number): number {
  if (choice === 1) {
    return 1;
  }

  if (choice < 1) {
    return 0;
  }

  return 2;
}

export default createI18n({
  legacy: false,
  locale: import.meta.env.VITE_VUE_APP_I18N_LOCALE || defaultLocale,
  fallbackLocale: import.meta.env.VITE_VUE_APP_I18N_FALLBACK_LOCALE || defaultLocale,
  messages: messages,
  pluralRules: {
    en: pluralize,
    es: pluralize,
  },
});
